<h1 class="page-title">Mit teszünk?</h1>

<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok']">Programok</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/istentiszteletek']">Istentiszteletek</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/gyerekfogi']">Gyermek foglalkozások</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/ifi']">Ifjúsági alkalmak</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/hazasrandi']">Házasoknak</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/hazicsoportok']">Házicsoportok</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/taborok']">Táborok, konferenciák</a></p>

<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok']">Missziók</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok/bab']">Báb csapat</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok/pantomim']">Pantomim</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok/plantalt']">Plántált gyülekezeteink</a></p>
<p class="sub-item"><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok/misszionariusok']">Misszionáriusaink</a></p>

<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/bibliaiskola']">Bibliaiskola</a></p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/what-we-do.component.html